import { render, staticRenderFns } from "./AgendamientosListClient.vue?vue&type=template&id=3cdaacb1&scoped=true&"
import script from "./AgendamientosListClient.vue?vue&type=script&lang=js&"
export * from "./AgendamientosListClient.vue?vue&type=script&lang=js&"
import style0 from "./AgendamientosListClient.vue?vue&type=style&index=0&id=3cdaacb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdaacb1",
  null
  
)

export default component.exports